import {
    avoidSpecialRoadFlags,
    avoidSpecialRoadFlagsEnum,
    avoidTollRoadFlags,
    avoidTollRoadFlagsEnum,
    routerCountryTypes,
    routerTypesEnum,
} from "helpers/enums";
import { getInitialStateFromConfig } from "helpers/form";
import { getClientAvoidSpecialRoadFlags } from "helpers/regionDryingPeriods";
import { requiredField } from "helpers/validators";

const { GraphHopper, Yatrs } = routerTypesEnum;
const config = {
    routerType: {
        label: "Маршрутизатор",
        inputProps: { name: "routerType" },
        key: "routerType",
        propName: "routerType",
        required: true,
        validators: [requiredField],
    },
    routerProfile: {
        available: ({ routerType }) => Yatrs === routerType,
        label: "Профиль",
        key: "routerProfile",
        inputProps: { name: "routerProfile" },
        required: true,
        validators: [(value, data) => (data.routerType === routerTypesEnum.Yatrs ? requiredField(value) : "")],
        options: [],
    },
    useSpecialProfileForEmptyRoute: {
        available: ({ routerType }) => Yatrs === routerType,
        label: "Использовать отдельный профиль для порожних маршрутов",
        key: "useSpecialProfileForEmptyRoute",
        inputProps: { name: "useSpecialProfileForEmptyRoute" },
        type: "checkbox",
    },
    disallowToll: {
        available: ({ routerType }) => [GraphHopper, Yatrs].includes(routerType),
        label: "Избегать все платные дороги",
        key: "disallowToll",
        inputProps: { name: "disallowToll" },
        propName: "disallowToll",
        type: "checkbox",
    },
    disallowTollExceptM4: {
        available: ({ routerType }) => [GraphHopper, Yatrs].includes(routerType),
        label: "Избегать все платные дороги, кроме М4",
        key: "disallowTollExceptM4",
        inputProps: { name: "disallowTollExceptM4" },
        propName: "disallowTollExceptM4",
        type: "checkbox",
    },
    disallowTollExceptM12DRT: {
        available: ({ routerType }) => [GraphHopper, Yatrs].includes(routerType),
        label: "Избегать все платные дороги, кроме участка \"Дюртюли - Ачит\" М-12",
        key: "disallowTollExceptM12DRT",
        inputProps: { name: "disallowTollExceptM12DRT" },
        propName: "disallowTollExceptM12DRT",
        type: "checkbox",
    },
    avoidTollRoadFlags: {
        available: ({ routerType }) => [GraphHopper, Yatrs].includes(routerType),
        label: "Исключать платные дороги",
        key: "avoidTollRoadFlags",
        inputProps: { name: "avoidTollRoadFlags" },
        flags: ({ routerType }) =>
            routerType === GraphHopper
                ? avoidTollRoadFlags.filter((item) => item.value === avoidTollRoadFlagsEnum.CRR)
                : avoidTollRoadFlags,
        type: "flags",
    },
    avoidSpecialRoadFlags: {
        available: ({ routerType }) => [GraphHopper, Yatrs].includes(routerType),
        label: "Исключать особые дороги",
        key: "avoidSpecialRoadFlags",
        inputProps: { name: "avoidSpecialRoadFlags" },
        flags: ({ routerType }) =>
            getClientAvoidSpecialRoadFlags(
                routerType === GraphHopper
                    ? avoidSpecialRoadFlags.filter((item) => item.value === avoidSpecialRoadFlagsEnum.MRR)
                    : avoidSpecialRoadFlags,
            ),
        type: "flags",
    },
    allowFerry: {
        available: ({ routerType }) => Yatrs === routerType,
        label: "Разрешить паромы",
        key: "allowFerry",
        inputProps: { name: "allowFerry" },
        type: "checkbox",
    },
    calcTolls: {
        available: ({ routerType }) => Yatrs === routerType,
        label: "Рассчитывать платные дороги",
        key: "calcTolls",
        inputProps: { name: "calcTolls" },
        type: "checkbox",
    },
    useIndividualAccount: {
        available: ({ routerType }) => Yatrs === routerType,
        label: "Использовать индивидуальную учетную запись",
        key: "useIndividualAccount",
        inputProps: { name: "useIndividualAccount" },
        type: "checkbox",
    },
    apiKey: {
        available: ({ routerType, useIndividualAccount }) => Yatrs === routerType && useIndividualAccount,
        label: "Api ключ",
        key: "apiKey",
        inputProps: { name: "apiKey", type: "text" },
        validators: [(value, data) => (data.useIndividualAccount ? requiredField(value) : "")],
        required: true,
    },
    country: {
        available: ({ routerType }) => Yatrs === routerType,
        label: "Ограничение по стране",
        key: "country",
        inputProps: { name: "country" },
        options: routerCountryTypes,
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
